[
  {
    "code": "GM-B",
    "name": "Banjul"
  },
  {
    "code": "GM-M",
    "name": "Central River"
  },
  {
    "code": "GM-L",
    "name": "Lower River"
  },
  {
    "code": "GM-N",
    "name": "North Bank"
  },
  {
    "code": "GM-U",
    "name": "Upper River"
  },
  {
    "code": "GM-W",
    "name": "Western"
  }
]